import httpClient, { httpFormDataClient } from "./httpClient";

const prefix = "/permissions";

export async function createPermission(partnerId, permissionData, permissionFiles) {
  const formData = new FormData();

  if (permissionFiles && permissionFiles.length > 0) {
    permissionFiles.forEach((file) => {
      formData.append("permissionFiles", file);
    });
  }

  Object.keys(permissionData).forEach((key) => {
    formData.append(key, permissionData[key]);
  });

  return (await httpFormDataClient.post(`${prefix}/${partnerId}`, formData))
    .data;
}

export async function deletePermissionFile(id) {
  return (await httpClient.delete(`${prefix}/permission-files/${id}`)).data;
}

export async function updatePermission(id, updateData) {
  return (await httpClient.patch(`${prefix}/${id}`, updateData)).data;
}

export async function uploadFilesToPermission(id, permissionFiles) {
  const formData = new FormData();

  if (permissionFiles && permissionFiles.length > 0) {
    permissionFiles.forEach((file) => {
      formData.append("permissionFiles", file);
    });
  }

  return (await httpFormDataClient.post(`${prefix}/${id}/files`, formData))
    .data;
}

export async function approvePermission(id, approveData) {
  return (await httpClient.patch(`${prefix}/${id}/approve`, approveData)).data;
}

export async function getPermissionsByPartner(partnerId) {
  return (await httpClient.get(`${prefix}/partner/${partnerId}`)).data;
}

export async function getPermissionById(id) {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}

export async function getAllPermissions(params = {}) {
  const queryParams = new URLSearchParams();
  
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.offset) queryParams.append('offset', params.offset);
  if (params.param) queryParams.append('param', params.param);
  if (params.sort) queryParams.append('sort', params.sort);
  if (params.order) queryParams.append('order', params.order);
  if (params.status) queryParams.append('status', params.status);
  if (params.permissionDate) queryParams.append('permissionDate', params.permissionDate);

  if (params.bossId) {
    const url = queryParams.toString() ? `${prefix}/by-direct-boss/${params.bossId}?${queryParams.toString()}` : `${prefix}/by-direct-boss/${params.bossId}`;
    return (await httpClient.get(url)).data;
  }

  const url = queryParams.toString() ? `${prefix}?${queryParams.toString()}` : prefix;
  return (await httpClient.get(url)).data;
}

export async function getAllPermissionsWithoutPagination() {
  return (await httpClient.get(`${prefix}/all`)).data;
}

export async function getTodayPermissionsByPartner(partnerId) {
  return (await httpClient.get(`${prefix}/partner/${partnerId}/today`)).data;
}

export async function hasActivePermission(partnerId) {
  return (await httpClient.get(`${prefix}/partner/${partnerId}/active`)).data;
}

export async function getActivePermissionByPartner(partnerId, date) {
  return (await httpClient.get(`${prefix}/partner/${partnerId}/active/${date}`)).data;
} 